<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='规范科室管理' label2="修改规范科室" url="/standardsection/standardsectionlist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">轮转规范：</label>
            <div class="col-xl-2">
              <el-form-item prop="standardid" :rules="{required: true, message: '轮转规范不能为空', trigger: 'blur'}">
                <el-select v-model="form.standardid" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in standardOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <label class="col-xl-1 col-form-label">标准科室：</label>
            <div class="col-xl-2">
              <el-form-item prop="ssecid" :rules="{required: true, message: '标准科室不能为空', trigger: 'blur'}">
                <el-select v-model="form.ssecid" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in sectionOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <label class="col-xl-1 col-form-label">轮转时间：</label>
            <div class="col-xl-2">
              <el-form-item prop="sstime" :rules="{required: true, message: '轮转时间不能为空', trigger: 'blur'}">
                <el-input placeholder="请输入轮转时间" v-model="form.sstime">
                  <template slot="append">月</template>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">描述：</label>
            <div class="col-xl-8">
              <el-input type="textarea" v-model="form.sscontent"></el-input>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <SaveButton :url='saveUrl' back="/standardsection/standardsectionlist"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StandardSectionEdit',
    data() {
      return {
        form: {
          id:'',
          standardid: '',
          ssecid: '',
          sstime: '',
          sscontent: '',
          token: ''
        },
        standardOptions: [],
        sectionOptions: [],
        saveUrl: this.$utils.Url.zpgl + '/api/APIStandardSection/Update'
      }
    },
    methods:{
      LoadStandard: function() {
        var args = {
          token: this.form.token,
          pageSize: 99999,
          currentPage: 1
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStandard/List', args, function(data) {
          for (var i = 0; i < data.Data.length; i++) {
            var arg = {
              value: data.Data[i]["StandardID"],
              label: data.Data[i]["StandardName"]
            }
            that.standardOptions.push(arg)
          }
          that.LoadCycleSection()
        }, null, null, null)
      },
      LoadCycleSection: function() {
        var args = {
          token: this.form.token,
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CycleSecion', args, function(data) {
          for (var i = 0; i < data.Data.length; i++) {
            var arg = {
              value: data.Data[i]["DictItemID"],
              label: data.Data[i]["DictItemName"]
            }
            that.sectionOptions.push(arg)
          }
          that.LoadStandardSectionInfo()
        }, null, null, null)
      },
      LoadStandardSectionInfo:function(){
        var args = {
          id: this.form.id,
          token: this.form.token
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStandardSection/Info', args, function(data, model) {
          model.standardid = data.Data.StandardID
          model.ssecid = data.Data.SSecID
          model.sstime = data.Data.SSTime
          model.sscontent = data.Data.SSContent
        }, null, null, this.form)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      this.LoadStandard()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }
</style>

<style scoped="scoped">
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
</style>
